module.exports = __webpack_public_path__ + "img/rightcalf-endomorph-female.449c518c.svg";